import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative pt-[72px] bg-cream overflow-hidden">
      <div className="relative mx-auto max-w-[1440px] px-6 md:px-10 pt-10 md:pt-16 pb-20">
        <div className="grid grid-cols-1 xl:grid-cols-12 gap-8 items-stretch">
          {/* Left: typographic statement */}
          <div className="lg:col-span-6 flex flex-col justify-between min-h-[520px] md:min-h-[640px]">
            <div className="flex items-center gap-3">
              <span className="w-2 h-2 rounded-full bg-lime-accent animate-pulse" />
              <span className="text-xs uppercase tracking-widest2 text-ink/60">
                Software Development & Digital Solutions
              </span>
            </div>

            <div>
              <h1 className="text-display text-5xl md:text-7xl lg:text-[80px] leading-[0.95] text-balance">
                Technology
                <br />
                that <span className="italic font-light">scales</span>
                <br />
                your business.
              </h1>
              <p className="mt-6 max-w-lg text-ink/70 text-base md:text-lg leading-relaxed">
                We are an IT company specializing in custom software development for businesses
                and private users, as well as comprehensive turnkey digital solutions.
                From idea to launch — and beyond.
              </p>

              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <Link
                  to="/contact"
                  className="group inline-flex items-center justify-center gap-2 rounded-full bg-ink text-cream px-7 py-4 text-xs font-semibold uppercase tracking-widest2 cursor-pointer whitespace-nowrap hover:bg-terracotta transition-colors duration-300"
                >
                  Get a free consultation
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-cream/15 group-hover:bg-cream/25 transition-colors">
                    <i className="ri-arrow-right-line text-sm" />
                  </span>
                </Link>
                <Link
                  to="/services"
                  className="inline-flex items-center justify-center gap-2 rounded-full border border-ink/20 text-ink px-7 py-4 text-xs font-semibold uppercase tracking-widest2 cursor-pointer whitespace-nowrap hover:border-ink transition-colors"
                >
                  Explore our services
                </Link>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-4 pt-10 border-t border-ink/10">
              <div>
                <div className="text-display text-3xl md:text-4xl">150+</div>
                <div className="text-xs uppercase tracking-widest2 text-ink/50 mt-1">Projects Delivered</div>
              </div>
              <div>
                <div className="text-display text-3xl md:text-4xl">50+</div>
                <div className="text-xs uppercase tracking-widest2 text-ink/50 mt-1">Team Members</div>
              </div>
              <div>
                <div className="text-display text-3xl md:text-4xl">4.9<span className="italic font-light">★</span></div>
                <div className="text-xs uppercase tracking-widest2 text-ink/50 mt-1">Client Rating</div>
              </div>
            </div>
          </div>

          {/* Right: abstract tech visual */}
          <div className="lg:col-span-6 relative">
            <div className="relative h-[520px] md:h-[640px] rounded-3xl overflow-hidden bg-ink/5">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20modern%20technology%20visualization%20with%20flowing%20data%20streams%20geometric%20shapes%20soft%20warm%20cream%20and%20dark%20charcoal%20tones%20minimalist%20editorial%20digital%20art%20style%20clean%20professional%20aesthetic%20no%20text&width=900&height=1100&seq=vantory-hero-1&orientation=portrait"
                alt="Digital solutions visualization"
                className="absolute inset-0 w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/20 via-transparent to-transparent" />

              {/* Floating card */}
              <div className="absolute top-6 right-6 md:top-8 md:right-8 bg-cream/95 backdrop-blur rounded-2xl p-4 w-[240px] shadow-[0_1px_0_rgba(0,0,0,0.04)]">
                <div className="flex items-center gap-2 mb-3">
                  <span className="w-2 h-2 rounded-full bg-lime-accent" />
                  <span className="text-[10px] uppercase tracking-widest2 text-ink/60">Active Project</span>
                </div>
                <p className="text-display text-lg leading-tight">E-Commerce Platform</p>
                <p className="text-xs text-ink/60 mt-1">Full-stack · 8-week sprint</p>
                <div className="mt-3 flex items-center gap-2">
                  <div className="flex-1 h-1.5 rounded-full bg-ink/10 overflow-hidden">
                    <div className="h-full w-[75%] rounded-full bg-lime-accent" />
                  </div>
                  <span className="text-[10px] text-ink/60">75%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="relative border-y border-ink/10 bg-cream py-5 overflow-hidden">
        <div className="flex marquee-track whitespace-nowrap gap-12 text-ink/70">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex items-center gap-12 pr-12">
              {["Custom Software","IT Consulting","Digital Marketing","Web Development","Mobile Apps","Cloud Solutions","UI/UX Design","QA & Testing"].map((t) => (
                <span key={t} className="text-display text-3xl md:text-5xl flex items-center gap-12">
                  {t}
                  <span className="text-terracotta">✦</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}